import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { FiArrowLeft } from "react-icons/fi";
import { Nav, Tab } from "react-bootstrap";
import Layout from "components/Layout";
import Loading from "components/Loading";
import GroupInfo from "components/Groups/GroupInfo";
import GroupEmployees from "components/Groups/GroupEmployees";
import GroupSupervisors from "components/Groups/GroupSupervisors";
import GroupStaffingLevels from "components/Groups/GroupStaffingLevels";
import { groupsService, employeesService } from "services";
import { showModal, hideModal } from "actions/modalActions";
import * as groupsActions from "actions/groupsActions";
import * as calendarsActions from "actions/calendarsActions";
import * as employeesActions from "actions/employeesActions";
import Modal from "components/Modal";
import { withTranslation } from 'react-i18next';

class Group extends React.Component {
	constructor(props) {
		super(props);

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getGroupEmployees = this.getGroupEmployees.bind(this);

		this.state = {
			loading: true,
			group: {},
			errors: {},
			error_footer: "",
		};
	}

	closeModal() {
		this.props.hideModal();
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || "Error",
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	async componentDidMount() {
		this.getGroupData();
	}

	async resolveGroupAssignments(employees, groupId) {
		return Promise.all(employees.map(async (employee) => {
			const currentAssignment = employee.employee_with_group;
			const assignmentGroupId = currentAssignment && currentAssignment.group
				? currentAssignment.group.id
				: null;

			if (Number(assignmentGroupId) === Number(groupId)) {
				return employee;
			}

			const employeeGroupsResponse = await employeesService.getGroups(employee.id);
			const employeeGroups = Array.isArray(employeeGroupsResponse)
				? employeeGroupsResponse
				: employeeGroupsResponse.ok && Array.isArray(employeeGroupsResponse.data)
					? employeeGroupsResponse.data
					: [];

			if (employeeGroups.length === 0) {
				return employee;
			}

			const groupAssignment = employeeGroups
				.filter((assignment) => assignment.group &&
					Number(assignment.group.id) === Number(groupId))
				.sort((a, b) => moment(b.start_day).valueOf() - moment(a.start_day).valueOf())[0];

			return groupAssignment
				? { ...employee, employee_with_group: groupAssignment }
				: employee;
		}));
	}

	async getGroupData() {
		const groupId = this.props.match.params.id;

		const group_employees_response = await employeesService.getAll({
			history_group_id: groupId,
			variant: "detailed",
		});
		const group_employees_response_data = group_employees_response.ok
			? group_employees_response.data
			: [];
		const group_employees = await this.resolveGroupAssignments(
			group_employees_response_data,
			groupId
		);

		const group_from_list = await groupsService.getAll({
			id: groupId,
			variant: "detailed",
		});

		if (
			group_from_list.ok &&
			group_from_list.data &&
			group_from_list.data.length > 0
		) {
			this.props.getSelectableCalendars();
			this.props.getChildGroups();
			this.props.getSelectableEmployees({ enabled: true });
			this.props.getGroupStaffingLevels(groupId);
			this.props.getSelectableStaffingLevels();

			this.setState({
				group: group_from_list.data[0],
				group_employees,
				loading: false,
			});
		} else {
			this.setState({
				loading: false,
			});
			toastr.error(this.props.t('common.error'), this.props.t('groups.errorLoadingGroup'));
			this.props.history.push("/");
		}
	}

	async getGroupEmployees() {
		const groupId = this.props.match.params.id;

		const group_employees_response = await employeesService.getAll({
			history_group_id: groupId,
			variant: "detailed",
		});
		const group_employees_response_data = group_employees_response.ok
			? group_employees_response.data
			: [];
		const group_employees = await this.resolveGroupAssignments(
			group_employees_response_data,
			groupId
		);

		this.setState({
			group_employees,
		});
	}

	handleBackClick = () => {
		this.props.history.goBack();
	};

	// Función para actualizar el grupo en el estado local
	updateGroup = (updatedGroup) => {
		this.setState({
			group: updatedGroup,
		});
	};

	getContent = () => {
		if (this.state.loading) {
			return <Loading />;
		}

		if (!this.state.group || !this.state.group.id) {
			return this.props.t('groups.errorLoadingGroup');
		}

		const { group, group_employees } = this.state;

		return (
			<article className="card" key={group.id}>
				<div className="card-header">
					<h2 className="card-title">{group.name}</h2>
				</div>

				<Tab.Container defaultActiveKey="info">
					<Nav variant="tabs">
						<Nav.Item>
							<Nav.Link eventKey="info">{this.props.t('groups.tabs.info')}</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="empleados">{this.props.t('groups.tabs.employees')}</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="supervisores">{this.props.t('groups.tabs.supervisors')}</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="necesidades">
								{this.props.t('groups.tabs.staffing')}
							</Nav.Link>
						</Nav.Item>
					</Nav>
					<Tab.Content>
						<Tab.Pane eventKey="info">
							<GroupInfo group={group} updateGroup={this.updateGroup} />
						</Tab.Pane>
						<Tab.Pane eventKey="empleados">
							<GroupEmployees
								group_employees={group_employees}
								group={group}
								getGroupEmployees={this.getGroupEmployees}
							/>
						</Tab.Pane>
						<Tab.Pane eventKey="supervisores">
							<GroupSupervisors group={group} />
						</Tab.Pane>
						<Tab.Pane eventKey="necesidades">
							<GroupStaffingLevels group={group} />
						</Tab.Pane>
					</Tab.Content>
				</Tab.Container>
			</article>
		);
	};

	render() {
		return (
			<>
				<Layout configSidebar={true} className="page-group" context="groups">
					<div className="heading">
						<h1 className="title">
							<FiArrowLeft
								className="button-icon"
								onClick={this.handleBackClick}
							/>{" "}
							{this.props.t('groups.title')}
						</h1>
					</div>

					<div className="container">{this.getContent()}</div>
				</Layout>
				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.calendarsReducer,
		...reducers.groupsReducer,
		loading: reducers.groupsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllGroups: () => dispatch(groupsActions.getAllGroups()),
	getSelectableCalendars: () =>
		dispatch(calendarsActions.getSelectableCalendars()),
	getChildGroups: () => dispatch(groupsActions.getChildGroups()),
	getGroupStaffingLevels: (groupId) =>
		dispatch(groupsActions.getGroupStaffingLevels(groupId)),
	getSelectableStaffingLevels: () =>
		dispatch(groupsActions.getSelectableStaffingLevels()),
	getSelectableEmployees: (options) =>
		dispatch(employeesActions.getSelectableEmployees(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Group));

//<GroupEmployees group={group} />
